import React from "react";
import { Clock, MapPin, Search, Sparkles, X } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function PremiumMarinaSearch({ copy, value, onChange, suggestions = [], total = 0, popularPlaces = [] }) {
  const [open, setOpen] = React.useState(false);
  const quick = popularPlaces.length ? popularPlaces.slice(0, 4) : ["Port Hercules Monaco", "Marina di Porto Cervo", "Porto Montenegro", "ACI Marina Rovinj"];

  const select = (text) => {
    onChange(text);
    setOpen(false);
  };

  return (
    <div className="relative w-full">
      <div className="relative rounded-[1.75rem] border border-white/15 bg-white/95 shadow-2xl shadow-cyan-950/30 backdrop-blur-xl">
        <Search className="absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-cyan-700" />
        <Input
          value={value}
          onChange={(event) => { onChange(event.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          onBlur={() => setTimeout(() => setOpen(false), 140)}
          placeholder={copy.searchPlaceholder}
          className="h-16 rounded-[1.75rem] border-0 bg-transparent pl-14 pr-12 text-base font-bold text-slate-950 shadow-none focus-visible:ring-0"
          aria-label={copy.searchAria}
        />
        {value && <button type="button" onClick={() => onChange("")} className="absolute right-4 top-1/2 grid h-9 w-9 -translate-y-1/2 place-items-center rounded-full bg-slate-100 text-slate-600 hover:bg-cyan-50 hover:text-cyan-700" aria-label={copy.clearSearch}><X className="h-4 w-4" /></button>}
      </div>

      <div className="mt-3 flex flex-wrap items-center gap-2 text-sm text-cyan-50/85">
        <Sparkles className="h-4 w-4 text-cyan-200" /> {total} {copy.instantResults}
        <span className="hidden sm:inline">· {copy.popular}</span>
        {quick.map((item) => <button key={item} type="button" onMouseDown={(event) => event.preventDefault()} onClick={() => select(item)} className="rounded-full border border-white/25 bg-white/15 px-3 py-1.5 font-bold text-white backdrop-blur hover:bg-white/25">{item}</button>)}
      </div>

      {open && suggestions.length > 0 && (
        <div className="absolute z-30 mt-3 w-full overflow-hidden rounded-3xl border border-white/15 bg-slate-950/95 shadow-2xl backdrop-blur-2xl">
          {suggestions.map((suggestion) => (
            <button key={`${suggestion.type}-${suggestion.value}`} type="button" onMouseDown={() => select(suggestion.value)} className="flex w-full items-center gap-3 px-4 py-3 text-left text-white transition hover:bg-cyan-300/10">
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-cyan-300/15 text-cyan-200">{suggestion.type === "recent" ? <Clock className="h-4 w-4" /> : <MapPin className="h-4 w-4" />}</span>
              <span className="min-w-0"><span className="block truncate text-sm font-black">{suggestion.label}</span><span className="block text-xs capitalize text-cyan-50/55">{copy[suggestion.type] || suggestion.type}</span></span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}